import React from "react";
import HomeImprovementImage from "../../../assets/AssetTypes/HomeImprovement.svg";
import AutoImage from "../../../assets/AssetTypes/Auto.svg";
import EducationImage from "../../../assets/AssetTypes/Education.svg";
import HealthImage from "../../../assets/AssetTypes/Health.svg";
import OtherImage from "../../../assets/AssetTypes/Other.svg";
import TravelImage from "../../../assets/AssetTypes/Travel.svg";
import Text from "../../shared/components/Text";
import { assetTypes, ONBOARDING_FULFILLED_BY_TYPES } from "../../shared/config";
import { Typography } from "@material-ui/core";

export const SLIDER_STEPS = {
  WELCOME_STEP: "WELCOME_STEP",
  WHAT_IS_NEMURU: "WHAT_IS_NEMURU",
  WHAT_WILL_YOU_NEED: "WHAT_WILL_YOU_NEED",
  WHAT_WILL_YOU_NEED_INTERNATIONAL_STUDENT:
    "WHAT_WILL_YOU_NEED_INTERNATIONAL_STUDENT",
  WELCOME_AND_WHAT_WILL_YOU_NEED: "WELCOME_AND_WHAT_WILL_YOU_NEED",
};

export const DEFAULT_SLIDER_STEPS = {
  0: SLIDER_STEPS.WELCOME_STEP,
  1: SLIDER_STEPS.WHAT_IS_NEMURU,
  2: SLIDER_STEPS.WHAT_WILL_YOU_NEED,
};

export const NO_NEMURU_SLIDER_STEPS = {
  0: SLIDER_STEPS.WELCOME_STEP,
  1: SLIDER_STEPS.WHAT_WILL_YOU_NEED,
};

export const BORROWER_ONLINE_SLIDER_STEPS = {
  0: SLIDER_STEPS.WHAT_WILL_YOU_NEED,
};

export const NO_NEMURU_INTERNATIONAL_STUDENT_SLIDER_STEPS = {
  0: SLIDER_STEPS.WELCOME_STEP,
  1: SLIDER_STEPS.WHAT_WILL_YOU_NEED_INTERNATIONAL_STUDENT,
};

export const SLIDER_COLLECTIONS_BY_ON_BOARDING_TYPE = {
  [ONBOARDING_FULFILLED_BY_TYPES.MERCHANT_POS]: NO_NEMURU_SLIDER_STEPS,
  [ONBOARDING_FULFILLED_BY_TYPES.BORROWER_ONLINE]: BORROWER_ONLINE_SLIDER_STEPS,
};

export const LOAN_ASSET_TYPES = {
  [assetTypes.HOME_IMPROVEMENT]: {
    image: HomeImprovementImage,
  },
  [assetTypes.UTILITIES_SUPPLY]: {
    image: HomeImprovementImage,
  },
  [assetTypes.HEALTH]: {
    image: HealthImage,
  },
  [assetTypes.EDUCATION]: {
    image: EducationImage,
  },
  [assetTypes.TRAVEL]: {
    image: TravelImage,
  },
  [assetTypes.MINIMAL_AUTO]: {
    image: AutoImage,
  },
  [assetTypes.AUTO]: {
    image: AutoImage,
  },
  [assetTypes.OTHER]: {
    image: OtherImage,
  },
  [assetTypes.CREDIT_LINE]: {
    image: OtherImage,
  },
  [assetTypes.CARD]: {
    image: OtherImage,
  },
  [assetTypes.MINIMAL]: {
    image: OtherImage,
  },
};

export const infoDataSlider = [
  {
    title: <Text tId="WHICH_DOCUMENTS" />,
    description: (
      <>
        <ul style={{ padding: 0, paddingLeft: 16, margin: 0 }}>
          <li>
            <Typography variant="body2">
              <Text tId="DNI_OR_NIE" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="NIE_EU_PASSPORT" />
            </Typography>
          </li>
        </ul>
      </>
    ),
  },
  {
    title: <Text tId="WHAT_DATA_REQUESTED" />,
    description: (
      <>
        <ul style={{ padding: 0, paddingLeft: 16, margin: 0 }}>
          <li>
            <Typography variant="body2">
              <Text tId="ENTRANCE_DATE" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="OWNERSHIP_CONTRACT" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="MORTAGE_EXPENSES" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="MARITAL_REGIME_TYPES" />
            </Typography>
          </li>
          <li style={{ paddingTop: 4 }}>
            <Typography variant="body2">
              <Text tId="IBAN" />
            </Typography>
          </li>
        </ul>
      </>
    ),
  },
];
